import React from 'react';
import { translate } from 'react-i18next';
import { Layout } from 'antd';
import { Helmet } from 'react-helmet';
import i18next from 'i18next';

import ResponsiveTabs from 'Parts/ui/components/ResponsiveTabs';
import AdminTitleBar from 'Parts/common/AdminTitleBar';
import UserInboxForm from './UserInboxFormContainer';
import SendMessagePage from './SendMessagePageContainer';
import BlockedUsers from './BlockedUsersContainer';
import SavedDrafts from './SavedDraftsContainer';
import Reports from './ReportsContainer';

import userInboxEN from './locales/UserInbox_en.json';
import userInboxFR from './locales/UserInbox_fr.json';

import './UserInbox.less';


class UserInbox extends React.Component {
    constructor(props) {
        super(props);

        i18next.addResourceBundle('en', 'UserInbox', userInboxEN);
        i18next.addResourceBundle('fr', 'UserInbox', userInboxFR);
    }

    render() {
        const { t, session } = this.props;

        let tabPages = [{
            title: t('READ'),
            slug: 'inbox',
            container: props => {
                return <UserInboxForm {...this.props} />
            }
        }, {
            title: t('WRITE'),
            slug: 'new',
            container: props => {
                return <SendMessagePage {...this.props} />
            }
        }, {
            title: t('Blocked Users'),
            slug: 'blocked-users',
            container: props => {
                return <BlockedUsers {...this.props} />
            }
        }, {
            title: t('Saved Drafts'),
            slug: 'saved-drafts',
            container: props => {
                return <SavedDrafts {...this.props} />
            }
        }]

        if(session.user.role === 'SUPERADMIN') {
            tabPages.push({
                title: t('Reports'),
                slug: 'reports',
                container: props => {
                    return <Reports {...this.props}/>
                }
            })
        }

        return (
            <Layout className="UserInbox">
                <Helmet>
                    <title>{t('Inbox')}</title>
                </Helmet>
                <div className="UserInbox__Content">
                    <AdminTitleBar
                        title={t('Inbox')}
                    />
                    <h4 class="beta-title">{t('Beta')} <a href="mailto:info@fundky.com">{t('here')}</a></h4>
                    <h4 class="beta-title">{t('Make sure you are verified')}</h4>
                    <ResponsiveTabs pages={tabPages} parentPage={this.props}/>
                </div>
            </Layout>
        )
    }
}

export default translate('UserInbox')(UserInbox);